import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { deserialize } from 'santee-dcts';
import { Settings } from '../../core';
import { AdminSponsor, AdminSponsorReadModel } from '../shared/sponsor';

@Injectable()
export class AdminSponsorsStorage {
    private readonly apiPath = 'admin/sponsors';

    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings
    ) { }

    public getAll(): Observable<AdminSponsor[]> {
            return this.http.get(`${this.settings.apiUrl}/${this.apiPath}`)
                .pipe(
                    map((r) => deserialize(r, AdminSponsorReadModel).sponsors)
            );
    }
}